import { SiteActivityEvent, generator } from '@cms-max/cms-browser-api-client'
import { GeneratorArgs } from './generateEventMap'
import { Activity, Component } from '@cms-max/medicare-api-sdk'

export const premiumBillsGenerator = generator(({ i18n }: GeneratorArgs) => {
  const ns = 'premiumBills'

  const createPremiumBillsLinkClickHandler = (
    elementId: string
  ) => (params: {
    linkText?: string,
    linkUrl?: string
  }): SiteActivityEvent => ({
    core: {
      elementId,
      property: 'MAX',
      activity: Activity.LinkClick,
      component: Component.Premiums,
      coreClickData: {
        linkText: params.linkText,
        linkUrl: params.linkUrl
      }
    }
  })

  return {
    premiums_premiumbills_learnaboutprograms_click: createPremiumBillsLinkClickHandler(
      'premiums_premiumbills_learnaboutprograms_click'
    ),
    premiums_premiumbills_billtype_hover: {
      core: {
        elementId: 'premiums_premiumbills_billtype_hover',
        activity: Activity.ToolTipRead,
        component: Component.Premiums,
        property: 'MAX',
        coreClickData: {
          linkText: i18n.t('billTypeTooltip', { ns })
        }
      }
    },
    premiums_premiumbills_paynow_click: createPremiumBillsLinkClickHandler(
      'premiums_premiumbills_paynow_click'
    ),
    premiums_premiumbills_backtopremiums_click: createPremiumBillsLinkClickHandler(
      'premiums_premiumbills_backtopremiums_click'
    ),
    premiums_premiumbills_back_click: createPremiumBillsLinkClickHandler('premiums_premiumbills_back_click')
  }
})

export type PremiumBillsKeys = keyof ReturnType<
  typeof premiumBillsGenerator
>

export default premiumBillsGenerator
